import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  TRANSLATION_GROUP_DATEPICKER,
  TRANSLATION_GROUP_DROPDOWN,
  TRANSLATION_GROUP_FILE_UPLOAD,
  TRANSLATION_GROUP_FORMS_COMMON,
  TRANSLATION_GROUP_MULTI_SELECT,
} from './constants';
import {
  getDatePickerTranslationKeys,
  getDropDownTranslationKeys,
  getFileUploadTranslationKeys,
  getFormCommonTranslationKeys,
  getMultiSelectTranslationKeys,
} from './translations';

export class FormsModule extends AppModule {
  addRoutes(): void {}

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_DATEPICKER, getDatePickerTranslationKeys);
    mapper.addTranslationsMap(TRANSLATION_GROUP_DROPDOWN, getDropDownTranslationKeys);
    mapper.addTranslationsMap(TRANSLATION_GROUP_FILE_UPLOAD, getFileUploadTranslationKeys);
    mapper.addTranslationsMap(TRANSLATION_GROUP_MULTI_SELECT, getMultiSelectTranslationKeys);
    mapper.addTranslationsMap(TRANSLATION_GROUP_FORMS_COMMON, getFormCommonTranslationKeys);
  }
}
